import React, { useState, useEffect } from 'react'

export interface RadioCircleProps {
  /**
   * Sets disabled style
   * @default 'false'
   */
  isDisabled?: boolean
  /**
   * Sets checked style
   * @default 'false
   */
  isChecked?: boolean
}

export const RadioCircle = (props: RadioCircleProps): React.ReactElement => {
  const { isDisabled = false, isChecked = false } = props

  const [checked, setChecked] = useState(isChecked)

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  const insideCheckedStyle = checked ? 'bg-flamingo' : 'bg-white'
  const insideStyle = isDisabled && checked ? 'bg-gray-50' : insideCheckedStyle
  const outsideCheckedStyle = checked ? 'border-flamingo' : 'border-gray'
  const outsideStyle = isDisabled ? 'border-gray-50' : outsideCheckedStyle

  return (
    <div className="inline-flex items-center">
      <div
        role="button"
        className={`bg-white border rounded-full ${outsideStyle} h-4 w-4 flex justify-center items-center`}
      >
        <div className={`${insideStyle} rounded-full h-2 w-2`} />
      </div>
    </div>
  )
}
